import { apiClient, assertOk } from "@/api/generated/client"

import type { ForHireStatusData } from "../../types/forHireSummaryTypes.ts"

export const getStatusData = async (): Promise<ForHireStatusData> => {
  const { data, error, response } = await apiClient.GET("/api/ForHire/truck-status")
  return assertOk(response, error, data)
}
